var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-grade"},[_c('header',[_c('CardTitle',[_vm._v(_vm._s(_vm.titleName))])],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"grade-count"})])
}]

export { render, staticRenderFns }